/** Shared input chrome for wizard / profile fields (TextInput, Email, Phone, Address). */
export const FIELD_INPUT_BASE_CLASS =
  'box-border h-[2.75rem] w-full shrink-0 overflow-hidden text-ellipsis whitespace-nowrap border-2 border-imovGray rounded-md px-1.5 py-0 text-lg leading-[2.75rem] sm:text-base focus:outline-none focus:border-imovPrimaryLight'

export const fieldInputClass = (options?: { withIcon?: boolean }) =>
  options?.withIcon ? `${FIELD_INPUT_BASE_CLASS} pl-10` : FIELD_INPUT_BASE_CLASS

/** Create-ad address search (taller, softer corners). */
export const CREATE_AD_ADDRESS_INPUT_CLASS =
  'w-full rounded-xl border border-gray-200 py-3 px-4 focus:outline-none focus:ring-0'
